var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-layout',{staticClass:"return-list-table",attrs:{"items":_vm.mapItems,"fields":[],"tileComponent":_vm.tableTileComponent}})}
var staticRenderFns = []

export { render, staticRenderFns }